import {announce} from '@github-ui/aria-live'
import {useMutation} from '@github-ui/react-query'
import {AlertIcon} from '@primer/octicons-react'
import {Button, VisuallyHidden} from '@primer/react'
import {useId} from 'react'

import styles from './TryActivityTimelineButton.module.css'

const TURN_ON_ERROR = 'The Activity timeline preview could not be turned on. Try again.'

type TryActivityTimelineButtonProps = {
  onTurnOn: () => Promise<void>
}

export function TryActivityTimelineButton({onTurnOn}: TryActivityTimelineButtonProps) {
  const errorId = useId()
  const turnOn = useMutation({
    mutationFn: onTurnOn,
    onError: () => announce(TURN_ON_ERROR, {assertive: true}),
  })

  return (
    <div className={styles.container}>
      {turnOn.isError && <VisuallyHidden id={errorId}>{TURN_ON_ERROR}</VisuallyHidden>}
      <Button
        variant="invisible"
        size="small"
        loading={turnOn.isPending}
        leadingVisual={turnOn.isError ? AlertIcon : undefined}
        aria-label={turnOn.isError ? 'Try the new Activity timeline, try again' : undefined}
        aria-describedby={turnOn.isError ? errorId : undefined}
        onClick={() => turnOn.mutate()}
      >
        {turnOn.isError ? (
          'Try again'
        ) : (
          <>
            <span aria-hidden="true">✨</span> Try the new Activity timeline
          </>
        )}
      </Button>
    </div>
  )
}
